import { Component, OnInit } from '@angular/core';
import { AbstractAdvancedInput } from '../abstract-advanced-input';

@Component({
  template: `
    <miq-year-input
      [(currentValue)]="value"
      [required]="configuration.required"
      [disabled]="configuration.isDisabled"
      [column]="configuration"
      [readonly]="readonly"
      [minDate]="configuration.min"
      [maxDate]="configuration.max"
    >
    </miq-year-input>
  `,
  standalone: false,
})
export class AdvancedYearInputComponent extends AbstractAdvancedInput implements OnInit {
  readonly = false;

  ngOnInit() {
    this.readonly = this.configuration.readonly;
  }
}
